import { derived, type Writable, type Readable, writable } from 'svelte/store';

export class SearchHeaderStore {
    displayOnDesktop: Writable<boolean>;
    displayOnMobile: Writable<boolean>;
    searchHeaderStyle: Writable<'full' | 'simple'>;
    withSearchButtonInNavBar: Readable<boolean>;

    constructor({
        displayOnDesktop,
        displayOnMobile,
        searchHeaderStyle,
    }: {
        displayOnDesktop: boolean;
        displayOnMobile: boolean;
        searchHeaderStyle: 'full' | 'simple';
    }) {
        this.displayOnDesktop = writable(displayOnDesktop);
        this.displayOnMobile = writable(displayOnMobile);
        this.searchHeaderStyle = writable(searchHeaderStyle);
        this.withSearchButtonInNavBar = derived(this.searchHeaderStyle, ($style) => {
            return $style === 'simple';
        });
    }
}
